export class Cuentas{
    constructor(
        public tipo: String,
        public cuenta: Number,
        public valor: Number

    ){}
}